import { ContactHQInfoData, ContactInfoSectionData } from './ContactsPage.types';

export const contactInfoSections: ContactInfoSectionData[] = [
  {
    title: 'Zákaznická podpora',
    items: [
      {
        email: 'info@mcare.cz',
        name: 'Oddělení zákaznické podpory',
        phone: '+420 734 878 505',
        position: 'Oddělení zákaznické podpory',
      },
    ],
  },
];

export const hqInfo: ContactHQInfoData = {
  title: 'Sídlo společnosti',
  name: 'MAXCARE CZ s.r.o.',
  address: 'Olbrachtova 2006/9, 140 00 Praha 4-Krč, Česko',
  emails: ['info@mcare.cz'],
  comment: '',
  vatNo: '19811969',
  regNo: 'CZ19811969',
};
